import { entityId } from './entityId';

// Single source of truth for "click on a mix → open its Mixpedia page".
// Id-only: clicks navigate by identity, never by text — only the search box
// text-searches. Returns the searchMixes `filters` object, or null when the
// object carries no identity at all (legacy pre-id rows; callers decide how
// to degrade).
//
// Note on keys: the server's db layer maps a NUMERIC `id` to m.id and a
// STRING `id` to m.public_id (db/index.js), so `{ id: entityId(mix) }` is
// correct for both shapes — no need to split id vs public_id client-side.
export function buildMixOpenFilters(mix) {
    if (!mix) return null;
    const id = entityId(mix);
    if (id) return { id };
    if (mix.link) return { link: mix.link };
    return null;
}
